module.exports = __webpack_public_path__ + "static/media/donation.761ab545.svg";